import React from "react";
import "./card.scss";

interface CardProps {
  identifier: string;
  children: React.ReactNode;
  additionalClassNames?: string;
}

export const Card: React.FC<CardProps> = ({ children, identifier, additionalClassNames = "" }) => (
  <div className={"card " + additionalClassNames} data-testid={"card-" + identifier}>
    {children}
  </div>
);
